__turbopack_context__.v({
  "nonDiscountedPrice": "hcX4Ca_nonDiscountedPrice",
});
